"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Control = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactSelect = require("react-select");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _rebrand = require("@lt/components/icons-react/rebrand");

var _constants = require("../../constants");

var _excluded = ["children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Control = function Control(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_reactSelect.components.Control, props, /*#__PURE__*/_react["default"].createElement(SearchIcon, {
    className: "".concat(_constants.departurePickerName, "__icon-search")
  }), children);
};

exports.Control = Control;
var SearchIcon = (0, _styledComponents["default"])(_rebrand.Search).withConfig({
  displayName: "Control__SearchIcon",
  componentId: "sc-28e5ew-0"
})(["height:20px;"]);